import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Text } from '@as/cotopaxi';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
const ColorOutOfStockMessage = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    return (_jsx(Box, { mobile: { spacing: { marginTop: 1, marginBottom: 1 } }, children: _jsx(Text, { inline: true, emphasized: true, children: t('product.colorNotAvailable') }) }));
};
export default ColorOutOfStockMessage;
